<style lang="scss">
  .call-stats{
    &__items {
      p{
        display: flex;
        justify-content: space-between;
        //max-width: 300px;
        margin: auto;
        padding: 5px;

        &:nth-child(2n) {
          background-color: #e8dcff;
        }
      }
    }
  }
</style>

<template>
    <section class="ui-stats-item call-stats">
      <div class="col-12">

        <h4 class="font-weight-bold text-center title-divider top-divider">Shows call stats for the last {{filters.days}} days</h4>

        <div style="min-height: 350px">
          <section class="call-stats__items mt-4"  v-if="!loadingStats">
<!--            <p class="body-text">Total Booked: <b>{{stats.booked.booked}}</b></p>-->
<!--            <p class="body-text">Total Completed: <b>{{stats.booked.completed}}</b></p>-->
            <p class="body-text" cy="total-completed">Total Completed: <b>{{stats.call.total_visits}}</b></p>
<!--            <p class="body-text">Terminated calls: <b>TO DO!!!</b></p>-->
<!--            <p class="body-text">Total Pauses: <b>{{stats.call.total_pauses}}</b></p>-->
<!--            <p class="body-text">Average Pauses: <b>{{stats.call.average_pauses.toFixed(1)}}</b></p>-->
<!--            <p class="body-text">Total Call Duration (mins): <b>{{stats.call.total_call_duration_mins}}</b></p>-->
<!--            <p class="body-text">Average Call Duration (mins): <b>{{stats.call.average_call_duration_mins.toFixed(1)}}</b></p>-->
          </section>

          <section v-else class="d-flex justify-content-center pb-4 pt-5 flex-wrap">
            <p class="full-width d-flex justify-content-center">Getting Stats...</p>
            <b-spinner variant="primary"></b-spinner>
          </section>
        </div>
      </div>
    </section>
</template>

<script>
  import VisitsService from '../../../services/VisitService';
  import HelperService from '../../../services/HelperService';

  export default {
    props: {
      filters: {
        required: true,
        type: Object,
      },
    },
    components: {},
    watch: {
      filters: {
        handler() {
          this.getAllStats();
        },
        deep: true,
      },
    },
    data() {
      return {
        helperService: new HelperService(),
        loadingStats: true,
        stats: {
          call: null,
          booked: null,
        },
      };
    },
    mounted() {
      this.getAllStats();
    },
    methods: {
      getAllStats() {
        if (this.filters.prisonId || this.filters.prisonGroupId) {
          this.loadingStats = true;

          const promises = [this.getBookedCompletedStats(), this.getCallStats()];

          Promise.all(promises).finally(() => {
            setTimeout(() => {
              this.loadingStats = false;
            }, 1000);
          });
        }
      },
      getCallStats() {
        return VisitsService.getVisitStatsAveragePauses(this.filters).then((res) => {
          this.stats.call = res.data;
        }).catch((err) => {
          console.log('could not get call stats', err);
          this.$toasted.error('Error getting call stats, please refresh and try again');
        })
      },
      getBookedCompletedStats() {
        return VisitsService.getVisitBookedAndCompletedStats(this.filters).then((res) => {
          this.stats.booked = res.data;
        }).catch((err) => {
          console.log('could not get booked and completed stats', err);
          this.$toasted.error('Error getting booked and completed stats, please refresh and try again');
        });
      },
    },
  };
</script>
